import React, { useContext, useEffect, useState } from 'react'
import './Draft.css'
import { useFormik } from 'formik'
import { useHistory } from 'react-router-dom'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { handleRedirectInternal } from '@/custom/common/components'
import MakeOffer from '../MakeOffer'
import Comments from '@/views/Comments/Comments'
import BulkListing from '../BulkListing'
import ListingTable from './ListingTable'
import Layout from '@/product/components/templates/Layout'
import reportContext from '@/product/context/report/reportContext'
import CustomSearch from '@/custom/components/molecules/CustomSearch'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import ProductContext from '@/product/context/product/productContext'
import commonContext from '@/product/context/common/commonContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomInput from '@/product/components/atoms/Inputs/CustomInput'
import CustomSelect from '@/product/components/atoms/Inputs/CustomSelect'
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material'
import { Padding } from '@mui/icons-material'
import AuthContext from '@/product/context/auth/authContext'
import AlertContext from '@/product/context/alert/alertContext'
const DraftListing = (props) => {
    const from = 'newDraftListing'
    const history = useHistory()
    const { secondparam } = useParams()
    const { getAllExportDownload } = useContext(reportContext)
    const dynamicContext = useContext(DynamicContext)
    const dashboardContext = useContext(commonContext)
    const { alldata_all_dropdown, draft_page_filters, updateDraftPageFilters } =
        useContext(CustomCommonContext)
    const productContext = useContext(ProductContext)
    const [bulkPopup, setBulkPopup] = useState(false)
    const [searchInfo, setSearchInfo] = useState({})
    const [tableValue, setTableValue] = useState([])
    const [modalOpen, setModalOpen] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [lotCount, setLotCount] = useState(0)
    const [searchKey, setSearchKey] = useState(0)
    const { project_tablefields } = dynamicContext
    const { getMainDashboardData } = dashboardContext
    const { all_products, getAllProducts } = productContext
    const authContext = useContext(AuthContext)
    const { user, isAuthenticated } = authContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        projectType: 0,
    })

    const toggleFullScreenPopup = (popup, status, id, projectType) => {
        if (user?.emp_type === 'seller') {
            if (user?.users_seller_account_status === 'completed') {
                if (popup && (status == 'new' || status == 'edit')) {
                    handleRedirectInternal(history, `listing/${status}/${id}`)
                } else if (popup) {
                    setManage({ popup, status, id, projectType })
                } else {
                    setManage({ popup, status: 'new', id: 0 })
                }
            } else {
                setAlert('Need to complete the onboarding', 'error')
            }
        } else {
            if (popup && (status == 'new' || status == 'edit')) {
                handleRedirectInternal(history, `listing/${status}/${id}`)
            } else if (popup) {
                setManage({ popup, status, id, projectType })
            } else {
                setManage({ popup, status: 'new', id: 0 })
            }
        }
    }

    const toggleBulkPopup = (popup, status) => {
        if (status === 'refresh') {
            searchFormik.handleSubmit()
        }
        setBulkPopup({ popup })
    }
    const toggleBulkPopup2 = (popup, status) => {
        if (user?.emp_type === 'seller') {
            if (user?.users_seller_account_status === 'completed') {
                setBulkPopup({ popup })
            } else {
                setAlert('Need to complete the onboarding', 'error')
            }
        } else {
            setBulkPopup({ popup })
        }
    }
    const custom = {
        action: {
            value: 'draft',
            type: 'in',
            field: 'p.market_status',
        },
        status: {
            value: '',
            type: 'in',
            field: 'p.status',
        },
        location_id: {
            value: [],
            type: 'array',
            field: 'p.location_id',
        },
        employee_id: {
            value: [],
            type: 'array',
            field: 'p.user_id',
        },
    }

    const searchFormik = useFormik({
        initialValues: draft_page_filters,
        onSubmit: (values) => {
            const latestPayload = {
                ...draft_page_filters,
                filters: {
                    ...draft_page_filters.filters,
                    ...values.filters,
                },
                page: 1,
            }
            updateDraftPageFilters(latestPayload)
            setIsLoading(true)
            getAllProducts(latestPayload, from, 'searchFormikOnSubmit')
        },
    })

    const resetForm = () => {
        searchFormik.resetForm()
        const resetValues = {
            ...draft_page_filters,
            page: 1,
            filters: searchFormik.initialValues.filters,
        }

        setSearchKey((prevKey) => prevKey + 1)

        updateDraftPageFilters(resetValues)
        setIsLoading(true)
        getAllProducts(resetValues, from, 'resetForm')
    }

    useEffect(() => {
        if (all_products?.from === from) {
            setLotCount(all_products.totalRecords)
        }
    }, [all_products])

    const searchInfoTemp = {
        formik: searchFormik,
        data: [
            {
                label: 'Search Listings',
                placeholder: 'Enter',
                class: 'col-12 searchFieldDraft',
                type: 'text',
                name: 'searchterm',
                filter: true,
                endAdornment: <img src="/assets/svg/search_draft.svg" />,
                // endAdornment:<span className='material-icons'>search</span>
            },
            {
                label: 'Date Added:',
                placeholder: 'MM/DD/YYYY',
                class: 'dateDraftCls',
                type: 'date',
                name: 'fromdate',
                filter: true,
                upperLabel: true,
            },
            {
                label: '',
                placeholder: 'MM/DD/YYYY',
                class: 'dateDraftCls',
                type: 'date',
                name: 'todate',
                filter: true,
                upperLabel: true,
            },
        ],
    }

    const filterElements = [
        'dimension_length',
        'dimension_width',
        'dimension_height',
        'dimension_unit',
        'weight_value',
        'weight_unit',
        'origin_zip',
        'location_id',
        'local_pickup_dates',
        'local_pickup_start_hour',
        'local_pickup_end_hour',
        'local_pickup_appt_per_slot',
        'local_pickup_slot_timeframe',
        'station_package_code',
        'station_warehouse',
    ]

    // console.log('@@@tableValue', tableValue)

    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'edit') {
            handleRedirectInternal(history, `listing/edit/${id}`)
        }
    }

    const onClickInvoiceEdit = (id, secondaryID, type) => {
        handleRedirectInternal(history, `invoice/view/${id}/${secondaryID}`)
    }

    useEffect(() => {
        if (project_tablefields && project_tablefields.length) {
            let dynamicValueAssign = {}
            let searchData = project_tablefields
            dynamicValueAssign.data = searchData
                .filter((item) => item.table_search === 1)
                .map((buscat) => {
                    return Object.assign(buscat, {
                        name: buscat.field,
                    })
                })
            setSearchInfo(dynamicValueAssign)
            let dynamicAssign = [...project_tablefields]
            dynamicAssign.map((data) => {
                if (data.field === 'auctiontitle') {
                    data.click = true
                    data.onclick = onClickEdit
                    data.clickID = 'id'
                    data.secondaryClickID = 'user_id'
                    data.clickType = 'edit'
                    data.type = 'hyperlink'
                } else if (data.field == 'buynow_project_id') {
                    data.filterField = 'p.id'
                    data.filterable = 1
                    data.label = 'Product ID'
                } else if (data.field == 'id') {
                    data.filterField = 'p.id'
                    data.filterable = 1
                    data.label = 'Product ID'
                } else if (data.field == 'buynow_common_invoice') {
                    data.click = true
                    data.onclick = onClickInvoiceEdit
                    data.clickID = 'buynow_common_invoice'
                    data.secondaryClickID = 'buynow_user_id'
                    data.clickType = 'edit'
                    data.type = 'hyperlink'
                } else if (data.field == 'category') {
                    data.type = 'singleSelect'
                } else if (data.field == 'conditionTypeId') {
                    data.valueOptions = alldata_all_dropdown
                        .filter(
                            (value) =>
                                value.variable === 'conditionTypeId' &&
                                value.level === 0
                        )
                        .map((item) => {
                            let valueChanged = {}
                            valueChanged.label = item.description
                            valueChanged.value = item.id.toString()
                            return valueChanged
                        })
                    data.type = 'singleSelect'
                } else if (data.field === 'location') {
                    data.location = true
                } else if (data.field === 'title') {
                    data.click = true
                    data.onclick = onClickEdit
                    data.clickID = 'id'
                    data.secondaryClickID = 'id'
                    data.clickType = 'edit'
                    data.type = 'hyperlink'
                }
            })

            if (secondparam === 'open') {
                dynamicAssign.push({
                    active: 1,
                    field: 'requiredFieldsStatus',
                    folder: null,
                    id: 21,
                    is_deletable: 0,
                    label: 'Status',
                    show_order: 500,
                    sort: 0,
                    sort_field: 'p.wprice',
                    table_search: 0,
                    type: 'tooltip',
                    tooltipTitle: 'requiredFields',
                    tooltipType: 'field',
                    view_page: '1',
                })
            }
            console.log('val=======>', dynamicAssign)
            setTableValue(dynamicAssign)
        }
        getMainDashboardData(global.customDashboardFilter)
    }, [project_tablefields, secondparam])

    return (
        <Layout>
            <div className="dashboard listing maillisting DftListing">
                <div className="draftHeaderWithText">
                    <h2>Draft Inventory</h2>
                    <div className="newDraftHeaderCnt">
                        <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-3">
                            <Button
                                id="listingDynamic_add"
                                variant="outlined"
                                className="btnOutlined mr-2"
                                onClick={() =>
                                    toggleFullScreenPopup(true, 'new', 0, 5)
                                }
                            >
                                <span className="material-icons">add</span>New
                                Single Listing
                            </Button>
                            <Button
                                id="listingDynamic_bulk"
                                variant="outlined"
                                className="btnOutlined"
                                onClick={() => toggleBulkPopup2(true)}
                            >
                                <span className="material-icons">add</span>New
                                Bulk Listing
                            </Button>
                            {/* <Button
                        id="listingDynamic_report"
                        variant="outlined"
                        className="btnOutlined"
                        onClick={() =>
                            getAllExportDownload({
                                action: 'export',
                                order: 'asc',
                                orderby: '',
                                search: 'all',
                                report: `${secondparam}_product_management`,
                            })
                        }
                    >
                        <span className="material-icons-outlined">
                            file_download
                        </span>
                        Export All Data
                    </Button> */}
                        </div>
                        {searchInfo ? (
                            <div className="dftlistignSearchContainer">
                                <CustomSearch
                                    key={searchKey}
                                    clearButton={true}
                                    resetForm={resetForm}
                                    searchInfo={searchInfoTemp}
                                    formik={searchFormik}
                                />
                                <div className="resultsCnt">
                                    ( {lotCount} Items )
                                </div>
                                {/* <div
                            className="listinTableBase_Root"
                            style={{ backgroundColor: 'transparent' }}
                        >
                            <div className="d-flex align-items-center justify-content-start flex-wrap endTimeSlot">
                                <div className="tableCerseInput">
                                    <small>Date Added : </small>
                                    <CustomInput
                                        placeholder="06/06/2024"
                                        endAdornment={
                                            <span className="material-icons-outlined">
                                                calendar_month
                                            </span>
                                        }
                                    />
                                </div>
                                <small className="selectedItemCount mt-4">
                                    to
                                </small>
                                <div className="tableCerseInput">
                                    {/* <small className="invisible"> 
                                    <small>Date Added : </small>
                                    <CustomInput
                                        placeholder="12/10/2024"
                                        endAdornment={
                                            <span className="material-icons-outlined">
                                                calendar_month
                                            </span>
                                        }
                                        // style={{ maxWidth: '120px' }}
                                    />
                                </div>
                                <small className="selectedItemCount mt-4">
                                    ( 24 Selected )
                                </small>
                            </div>
                        </div> */}
                            </div>
                        ) : null}
                    </div>
                </div>

                <ListingTable
                    action={`draft`}
                    pagination={true}
                    customFilter={custom}
                    isLoading={isLoading}
                    tableValue={tableValue}
                    searchInfo={searchInfo}
                    searchFormik={searchFormik}
                />
                <BulkListing
                    data={bulkPopup}
                    filterElements={filterElements}
                    function={toggleBulkPopup2}
                    ignoreFields={
                        global?.bulk_ignoreFields
                            ? global.bulk_ignoreFields
                            : []
                    }
                    customDescription={'name'}
                    imageUpload={true}
                />
            </div>
        </Layout>
    )
}

export default DraftListing
